import React, { useState, useEffect } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import RFQModal from "../components/RFQModal";

import AOS from "aos";
import "aos/dist/aos.css";

import { LuUsers, LuHeart, LuTrendingUp, LuDot } from "react-icons/lu";

import "../assets/css/CustomerEngmntSolution.css";

const CustomerEngmntSolution = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    AOS.init({
      duration: 900,
      once: true,
    });
  }, []);

  return (
    <div id="customer-engagement" >
      <Navbar />

      <RFQModal show={show} setShow={setShow} />

      {/* HERO */}

      <section className="ce-hero ">
        <div className="container ce-hero-content ">
          <div className="ce-hero-text" data-aos="fade-right">
            <span className="section-tag">
              NIGERIA & WEST AFRICA'S LEADING CUSTOMER ENGAGEMENT PROVIDER
            </span>

            <h1>
              Experiences people actually engage with.
            </h1>

            <p>
              Integrated digital solutions that turn every customer touchpoint
              into engagement — and that engagement into superior retention and
              growth.
            </p>

            <button className="ccsnl-btn" onClick={() => setShow(true)}>
              Book a Demo
            </button>
          </div>

          <div className="ce-hero-image" data-aos="fade-left">
            <img
              src="https://images.unsplash.com/photo-1552664730-d307ca884978?w=1200"
              alt=""
            />
          </div>
        </div>
      </section>

      {/* QUOTE SECTION */}

      <section className="ce-quote ">
        <div className="container">
          <span>“</span>

          <h2>
            As a leading provider of end-to-end customer engagement services in <strong>Nigeria and West Africa</strong>, we bring exceptional expertise in contact center, social engagement, and CRM under one roof.
          </h2>
        </div>
      </section>

      {/* FLEX CONTACT CENTER */}

      <section className="ce-flex ">
        <div className="container ce-flex-grid">
          <div data-aos="fade-right" className="ce-flex-text">
            <span className="section-tag">FLEXIBLE & MULTI-LINGUAL</span>

            <h2>A Contact Center Built to Flex With You</h2>

            <p>
              Our strategic partnerships with global leaders such as Microsoft
              and Ameyo give us a robust portfolio of world-class offerings — so
              we match the right solution to your business, not the other way around. Every
              engagement is built to drive efficiency and performance across three levels of
              the customer engagement value chain.
            </p>
          </div>

          <div className="ce-flex-image" data-aos="fade-left">
            <img
              src="https://images.unsplash.com/photo-1521791136064-7986c2920216?w=1200"
              alt=""
            />
          </div>
        </div>
      </section>

      {/* ACQUIRE RETAIN GROW */}

      <section className="ce-value-chain ">
        <div className="container pt-1">
          <span className="section-tag">THE VALUE CHAIN</span>

          <h2>Acquire. Retain. Grow.</h2>

          <p className="section-intro">
            Three levels of the customer engagement value chain each with a
            distinct
            <br /> mechanism, not just an adjective.
          </p>

          <div className="ce-cards">
            <div className="ce-card" data-aos="fade-up">
              <LuUsers />

              <h4>Acquire</h4>

              <p>
                Segment and target potential customers more accurately, with the
                right products and the right message improving lead generation,
                conversion, and onboarding.
              </p>
            </div>

            <div className="ce-card" data-aos="fade-up" data-aos-delay="200">
              <LuHeart />

              <h4>Retain</h4>

              <p>
                Responsive engagement, exceptional service, and speedy issue
                resolution turn casual buyers into loyal customers. We analyze
                churn dynamics to catch attrition risk before it happens.
              </p>
            </div>

            <div className="ce-card" data-aos="fade-up" data-aos-delay="400">
              <LuTrendingUp />

              <h4>Grow</h4>

              <p>
                Insights from customer engagement uncover new opportunities to
                grow their lifetime value through increased usage,
                cross-selling, and up-selling.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* MARKETING AUTOMATION */}

      <section className="ce-marketing">
        <div className="container ce-two-col">
          <div data-aos="fade-right">
            <span className="section-tag">MARKETING AUTOMATION</span>

            <h2>
              Transform Every Touch-point Into a Marketing Opportunity
            </h2>

            <p>
              Engage customers across every channel. Plan, execute, and measure{" "}
              multichannel campaigns from start to finish. Manage, nurture, and
              score leads to generate more revenue while streamlining planning and
              execution, and getting a true view of marketing ROI.
            </p>

            <button className="ccsnl-btn" onClick={() => setShow(true)}>
              Book a Demo
            </button>
          </div>

          <div className="ce-pill-grid" data-aos="fade-left">
            <div>
              <LuDot /> Lead Management
            </div>
            <div>
              <LuDot /> CRM Integration
            </div>
            <div>
              <LuDot /> Social Marketing
            </div>
            <div>
              <LuDot /> Marketing Analytics
            </div>
            <div>
              <LuDot /> Campaign Management
            </div>
            <div>
              <LuDot /> Resource Management
            </div>
          </div>
        </div>
      </section>

      {/* CRM */}

      <section className="ce-crm">
        <div className="container ce-two-col ">
          <div className="ce-pill-grid first" data-aos="fade-right">
            <div>
              <LuDot /> Development
            </div>
            <div>
              <LuDot /> Implementation
            </div>
            <div>
              <LuDot /> Testing & Upgrades
            </div>
          </div>

          <div data-aos="fade-left" className="second">
            <span className="section-tag">CRM FOUNDATION</span>

            <h2>Customer Relationship Management</h2>

            <p>
              A solid CRM foundation is critical to customer engagement success.
              We don't just help you identify the right CRM technology, we help
              you get your people and processes aligned to it, with change
              management strategies built in. Our CRM practice has over 9
              years implementing CRM solutions across a range of industries, and
              we're experts in Microsoft Dynamics 365 from development and
              implementation to testing, upgrades, and ongoing managed services.
            </p>
          </div>
        </div>
      </section>

      {/* CTA */}

      <section className="ce-cta">
        <div className="container">
          <h2>
            Turn every touch-point into an engagement your customers remember.
          </h2>

          <p>
            Book a demo and see the acquire-retain-grow chain built around your
            business.
          </p>

          <button className="ccsnl-btn" onClick={() => setShow(true)}>
            Book a Demo
          </button>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default CustomerEngmntSolution;
